import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource'
import { DirectBankBrand } from '../../model/types/payment-method-type';

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.MY,
  regionId: 1705,
  defaultCountryFrom: 'MY',
  defaultCountryFromOnfido: 'MYS',
  defaultCountryCodeFrom: 60,
  defaultCurrencyFrom: 'MYR',
  defaultLanguageCulture: 'en-MY',
  defaultLocation: {
    latitude: 3.1546872,
    longitude: 101.7136362
  },
  dateFormat: 'DD/MM/YYYY',
  postalCodeRegex:`^[1-9][0-9]{4}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['en-MY', 'ne-MY', 'bn-MY', 'id-MY', 'ms-MY'],
  regionalIp: '66.82.123.234',
  requireAddress: true,
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 0,
  directBankBrand: DirectBankBrand.FPX,
  distanceMetric: 'km',
  acceptInternationalCards:false,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: false,
  isEMEA: false,
  notShowMarketingPushAlert: true,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: [],
  applepayAdyenPaymentNetworks: [],
  adyenMerchantCapability: [],
  walletSettings:{
    isMerchantSupportEnable:true,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  showNewHomePage: false,
  riaPrepaidCardBinNumber: "53478085",
  canShowLogosOnQRScanner: true,
  airtimeServices:{
    isAirTimeSevice:true,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[
    {
      type: "send",
      icon: "../../assets/img/wallet/send.svg",
      title: "page.myRecipientsPage.eWalletSendButton",
      sortOrder: 1,
      canShowOptions: false,
      options:[
        {
          type: "sendmoney",
          title:"page.eWalletPage.sendMoneyOptionsTransfer",
          subTitle: "page.eWalletPage.sendMoneyOptionsTransferText",
          image: "assets/icons/global-smf-gray.svg",
          sortOrder: 1,
        }, {
          type: "wallet",
          title:"page.eWalletPage.sendMoneyOptionsWallet",
          subTitle: "",
          image: "assets/icons/wallet-tab-more.svg",
          sortOrder: 2,
        }
      ]
    }, {
      type: "card",
      icon: "../../assets/img/wallet/card.svg",
      title: "page.eWalletPage.transactionDetailsPage.cardLabel",
      sortOrder: 2,
    }, {
      type: "airtime",
      icon: "../../assets/img/wallet/airtime.svg",
      title: "page.topUpPage.airtimeLabel",
      sortOrder: 3,
    }, {
      type: "more",
      icon: "../../assets/img/wallet/more.svg",
      title: "global.moreNav",
      sortOrder: 4,
      options:[
        {
          type: "deposit",
          title:"page.activityPage.eWalletDepositLabel",
          subTitle: "",
          icon: "assets/icons/wallet_deposit.svg",
          iconForHome: "../../assets/img/wallet/deposit.svg",
          sortOrder: 1,
        }, {
          type: "withdraw",
          title:"page.activityPage.eWalletWithdrawLabel",
          subTitle: "",
          icon: "assets/icons/wallet_withdraw.svg",
          iconForHome: "../../assets/img/wallet/withdraw.svg",
          sortOrder: 2,
        }
      ]
    }
  ],
  isCountrySupportDecimal: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "wallet",
  adyenRegion: 'live-apse'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/MY.ts